import React, { FC } from 'react'
import { Typography } from '@mui/material'
import { format } from 'date-fns'
import { ProcessedEvent } from '../../types'
import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded'
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded'
import { useSchedulerPropsContext } from '../../context/schedulerContext'

export interface EventItemMultiDayContentProps {
  event: ProcessedEvent
  hasPrev?: boolean
  hasNext?: boolean
  showdate?: boolean
}

export const EventItemMultiDayContent: FC<
  EventItemMultiDayContentProps
> = ({ event, hasNext, hasPrev, showdate }) => {
  const { locale } = useSchedulerPropsContext()

  const NextArrow = ArrowRightRoundedIcon

  const PrevArrow = ArrowLeftRoundedIcon

  return (
    <div
      style={{
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography sx={{ fontSize: 11 }} noWrap>
        {hasPrev ? (
          <PrevArrow fontSize="small" sx={{ display: 'flex' }} />
        ) : (
          showdate &&
          format(event.start, 'hh:mm a', { locale: locale })
        )}
      </Typography>
      <Typography
        variant="subtitle2"
        align="center"
        sx={{ fontSize: 12 }}
        noWrap
      >
        {event.summary}
      </Typography>
      <Typography sx={{ fontSize: 11 }} noWrap>
        {hasNext ? (
          <NextArrow fontSize="small" sx={{ display: 'flex' }} />
        ) : (
          showdate &&
          format(event.end, 'hh:mm a', { locale: locale })
        )}
      </Typography>
    </div>
  )
}
